export const handleLoginAttempt = async () => {
  let endpointUrl = process.env.REACT_APP_BACKEND_URL + "/login";
  let email = document.getElementById("email-input").value;
  let password = document.getElementById("password-input").value;  
  try {
    const response = await fetch(endpointUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ "email" : email, "password" : password }),
    });
    const data = await response.json();
    if (!response.ok) {
      if(response.status===402){
        return {success:false,status:response.status,id:data.userId};
      }
      else{
        return {success:false,status:response.status}
      }
    }
    if(response.ok){
      return{success:true,status:response.status,id:data.userId}
    }
  } catch (error) {
    // Handle network or other errors
    console.error("Error:", error.message);
  }
};